import { render, staticRenderFns } from "./ServerDetails.vue?vue&type=template&id=31d3b3da&scoped=true"
import script from "./ServerDetails.vue?vue&type=script&lang=js"
export * from "./ServerDetails.vue?vue&type=script&lang=js"
import style0 from "./ServerDetails.vue?vue&type=style&index=0&id=31d3b3da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d3b3da",
  null
  
)

export default component.exports